module.exports = __webpack_public_path__ + "img/coffee-company-weiss.52694dd8.png";